const personalCenterMenu = [
  { name: '当前身份', path: '' },
  // {
  //   name: '消息中心',
  //   path: '/person-center/message-center/notice-list',
  //   children: [
  //     {
  //       name: '消息通知',
  //       path: '/person-center/message-center/notice-list'
  //     }
  //   ]
  // },
  {
    name: '账户信息',
    path: '/person-center/account-info/member-info',
    children: [
      {
        name: '基本信息',
        path: '/person-center/account-info/member-info'
      },
      {
        name: '修改密码',
        path: '/person-center/account-info/reset-password'
      }
      // ,
      // {
      //   name: '变更手机号',
      //   path: ''
      // }
      // {
      //   name: '银行账户管理',
      //   path: '/person-center/account-info/bank-account-manage/list'
      // }
      // {
      //   name: '关联账户管理',
      //   path: '/person-center/account-info/account-manage/list'
      // }
    ]
  },
  // {
  //   name: '我的资产',
  //   path: '/',
  //   children: [
  //     {
  //       name: '机动地',
  //       path: ''
  //     },
  //     {
  //       name: '股权',
  //       path: ''
  //     }
  //   ]
  // },
  {
    name: '我的流转业务',
    path: '/person-center/project/roll-out-project/list',
    children: [
      {
        name: '我的流转项目',
        path: '/person-center/project/roll-out-project/list'
      },
      // {
      //   name: '我的批量流转项目',
      //   path: '/person-center/project/batch-out-project/list'
      // },
      {
        name: '报名流转标的',
        path: '/person-center/project/sign-up-project/list'
      },
      {
        name: '竞价流转标的',
        path: '/person-center/project/bid-circulation-project/list'
      },
      {
        name: '成交流转项目',
        path: '/person-center/project/contracted-project/list'
      }
    ]
  },
  {
    name: '我的采购业务',
    path: '/person-center/purchase-business/purchase-project/list',
    children: [
      {
        name: '我的采购项目',
        path: '/person-center/purchase-business/purchase-project/list'
      },
      {
        name: '报名审核记录',
        path: '/person-center/purchase-business/sign-up-record/list'
      },
      {
        name: '报名采购标的',
        path: '/person-center/purchase-business/sign-up-purchase/list'
      },
      {
        name: '竞价采购标的',
        path: '/person-center/purchase-business/bid-purchase-project/list'
      },
      {
        name: '成交采购项目',
        path: '/person-center/purchase-business/contracting-project/list'
      },
      {
        name: '采购文件下载',
        path: '/person-center/purchase-business/purchase-file-download/list'
      }
    ]
  },
  {
    name: '我的服务订单',
    path: '/person-center/orders/trusteeship/list',
    children: [
      {
        name: '托管订单',
        path: '/person-center/orders/trusteeship/list'
      },
      {
        name: '农机订单',
        path: '/person-center/orders/farm-machinery/list/003'
      },
      {
        name: '飞防订单',
        path: '/person-center/orders/plant-protection/list/002'
      },
      {
        name: '金融订单',
        path: '/person-center/orders/finance/list'
      }
    ]
  },
  {
    name: '我的供需发布',
    path: '/person-center/supply-and-demand/list/1',
    children: [
      {
        name: '我发布的供应',
        path: '/person-center/supply-and-demand/list/1'
      },
      {
        name: '我发布的需求',
        path: '/person-center/supply-and-demand/list/2'
      }
    ]
  },
  // {
  //   name: '发票管理',
  //   path: '/person-center/invoice-pro/list',
  //   children: [
  //     {
  //       name: '发票管理',
  //       path: '/person-center/invoice-pro/list'
  //     }
  //   ]
  // },
  // {
  //   name: '我的托管业务',
  //   path: '/person-center/hosting/list',
  //   children: [
  //     {
  //       name: '持股卡查询',
  //       path: '/person-center/hosting/list'
  //     }
  //   ]
  // },
  // {
  //   name: '我的资产',
  //   path: '/person-center/my-assets/list',
  //   children: [
  //     {
  //       name: '我的资产',
  //       path: '/person-center/my-assets/list'
  //     },
  //     {
  //       name: '资源资产',
  //       path: '/person-center/resources-assets/list'
  //     }
  //   ]
  // },
  { name: '退出登录', path: '' }
];
const purchaseBudgetArr = [{ code: '0-50', name: '0-50万' }, { code: '50-100', name: '50-100万' }, { code: '100-200', name: '100-200万' },
  { code: '200-500', name: '200-500万' }, { code: '500-1000', name: '500-1000万' }, { code: '1000', name: '1000万及以上' }];

// 动态设置搜索和菜单栏背景颜色   动态设置主体部分背景颜色  sidebar不展示的路由数组
const routerArr = [
  '/person-center/project/batch-out-project/detail',
  '/person-center/project/roll-out-project/detail',
  '/person-center/project/sign-up-project/detail',
  '/person-center/project/sign-up-project/margin-payment',
  '/person-center/purchase-business/purchase-project/detail',
  '/person-center/purchase-business/purchase-project/confirm-announcement',
  '/person-center/purchase-business/purchase-project/upload-announcement-image',
  '/person-center/purchase-business/purchase-project/upload-public-image',
  '/person-center/purchase-business/purchase-project/audit-apply',
  '/person-center/purchase-business/purchase-project/create-contract',
  '/person-center/purchase-business/purchase-project/confirmation-letter',
  'person-center/purchase-business/sign-up-purchase/margin-payment',
  'person-center/purchase-business/sign-up-purchase/detail',
  '/person-center/purchase-business/contracting-project/file-list',
  '/person-center/purchase-business/contracting-project/contracting-contract-list',
  '/person-center/purchase-business/contracting-project/contracting-pay-list',
  '/person-center/purchase-business/contracting-project/contracting-transaction-list',
  '/person-center/project/roll-out-project/trans',
  '/person-center/project/roll-out-project/trans/creatcontract',
  '/person-center/project/contracted-project/confirm-deal-book',
  '/person-center/project/contracted-project/confirm-contract',
  '/person-center/project/contracted-project/contract-payment'
];

export {
  personalCenterMenu,
  purchaseBudgetArr,
  routerArr
};
